import { useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'
import { useCanal } from '../lib/tiempoReal'
import type { MisPuntos, Usuario } from '../lib/tipos'

/**
 * El contador del mes: los contratos que se le han activado, ya con las bajas
 * restadas. Sube solo cuando backoffice activa.
 *
 * Va en grande porque lo pidió así José el 15 de octubre: «que el comercial vea
 * los puntos en un tamaño considerable, que le queme la vista a los puntos».
 *
 * Y debajo, los que tiene en pendiente de activación. Esos contratos ya no le
 * salen en la lista —«desaparecen», dijo— pero el número tiene que verse, que si
 * no parece que se hayan perdido.
 */
export function Puntos({ usuario }: { usuario: Usuario }) {
  const clienteQuery = useQueryClient()

  const consulta = useQuery({
    queryKey: ['mis-puntos'],
    queryFn: () => api<MisPuntos>('/api/mis-puntos'),
  })

  useCanal(`usuario:${usuario.uuid}`, () => {
    void clienteQuery.invalidateQueries({ queryKey: ['mis-puntos'] })
    void clienteQuery.invalidateQueries({ queryKey: ['fichas'] })
  })

  if (consulta.data === undefined) return null

  const { puntos, pendientes_activacion: pendientes, mes } = consulta.data

  return (
    <div
      title={`Puntos activados en ${mes}`}
      className="shrink-0 rounded-xl bg-marca-50 px-3 py-2 md:w-full dark:bg-marca-700/20"
    >
      <p className="text-[0.65rem] font-semibold uppercase tracking-wide text-marca-700/70 dark:text-marca-100/70">
        Puntos
      </p>
      <p className="text-3xl font-extrabold leading-none text-marca-700 tabular-nums dark:text-marca-100">
        {puntos.toLocaleString('es-ES')}
      </p>
      {pendientes > 0 && (
        <p
          title="Contratos que ya has lanzado y están esperando que la compañía los active"
          className="mt-1 text-xs font-semibold text-sky-700 dark:text-sky-300"
        >
          +{pendientes.toLocaleString('es-ES')} pdt. activación
        </p>
      )}
    </div>
  )
}
